// TODO: привести все иконки к одному типу
export const CheckedIcon = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
    >
      <circle cx="23" cy="23" r="23" fill="#333333" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.476 26.7975L29.8877 16.6015C30.1998 16.2633 30.7271 16.2422 31.0652 16.5544C31.4034 16.8665 31.4245 17.3938 31.1123 17.7319L21.1123 28.5653C20.7913 28.9131 20.2454 28.924 19.9108 28.5893L16.5774 25.256C16.252 24.9305 16.252 24.4029 16.5774 24.0775C16.9029 23.752 17.4305 23.752 17.7559 24.0775L20.476 26.7975Z"
        fill="white"
      />
    </svg>
  );
};
